import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  category: 'Performance Marketing',
  items: ['Campagnes Meta Ads & Google Ads orientées performance', "Structuration des funnels d'acquisition", 'Lead generation B2B & B2C', 'Stratégie e-commerce (AOV, ROAS, CRO)', 'Analyse data marketing et attribution', 'Expansion internationale (MENA, Europe)']
}, {
  category: 'Conseil Marketing & Développement Commercial',
  items: ['Développement commercial via marketing de performance', 'Audit marketing complet', 'Conseil pour e-commerces (UX, catalogue, prix, marge)', 'Optimisation Shopify / WooCommerce / Prestashop', "Stratégies d'expansion produits & marchés", 'Plans marketing trimestriels et mensuels']
}, {
  category: 'IT Consulting & Ingénierie',
  items: ['Développement de plateformes sur mesure', 'Optimisation technique WordPress/WooCommerce', 'Architecture Cloud & DevOps (AWS, OVH, GCP)', 'Solutions de cybersécurité', 'Infrastructure (CDN, optimisation serveur, CI/CD)', 'Maintenance technique et améliorations continues']
}];
export function Services() {
  return <section className="py-40 bg-gray-50 relative" data-id="element-113">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" data-id="element-114" />

      <div className="max-w-7xl mx-auto px-6" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-24" data-id="element-116">
          <h2 className="text-6xl md:text-7xl font-black text-black mb-6 tracking-tight" data-id="element-117">
            Expertises Détaillées
          </h2>
          <p className="text-xl text-gray-600 font-light" data-id="element-118">
            Services complets pour débloquer votre croissance
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-119">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.12,
          ease: [0.16, 1, 0.3, 1]
        }} className="bg-white p-10 shadow-sm border border-gray-100 transition-all duration-500 hover:shadow-xl hover:border-gray-200" data-id="element-120">
              <h3 className="text-2xl font-bold text-black mb-7 pb-5 border-b-2 border-blue-500 tracking-tight" data-id="element-121">
                {service.category}
              </h3>
              <ul className="space-y-4" data-id="element-122">
                {service.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start gap-3 text-gray-700" data-id="element-123">
                    <span className="flex-shrink-0 w-1.5 h-1.5 bg-blue-500 mt-2.5" data-id="element-124" />
                    <span className="leading-relaxed font-light" data-id="element-125">{item}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}